import NiceModal from "@ebay/nice-modal-react";
import { lazy } from "react";

const ErrorModal = lazy(() => import("@components/ErrorModal"))
const Toast = lazy(() => import("@components/Toast"))

NiceModal.register("error-modal", ErrorModal);

// Toasts

NiceModal.register("toast", Toast);